import React, { FunctionComponent, ChangeEvent, useCallback } from 'react';
import { useForm } from 'react-hook-form';

import { SubmitButton } from 'components';

import { SingleFieldStepProps } from 'scenes/common/types';
import NameQuestion from 'scenes/common/components/Questions/NameQuestion';

const FIRST_NAME = 'personalContactFirstName';
const LAST_NAME = 'personalContactLastName';

export const FIRST_NAME_QUESTION =
  'What is the first name of the main policy holder?';
export const LAST_NAME_QUESTION =
  'What is the last name of the main policy holder?';

const PersonalPolicyContactStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'onNext'> & {
    defaultFirstName: string;
    defaultLastName: string;
  }
> = ({ onNext, defaultFirstName, defaultLastName }) => {
  const { formState: hooksForm, handleSubmit, errors, control } = useForm({
    mode: 'onChange',
  });

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, onChange: Function): void => {
      onChange(event.target.value?.trim());
    },
    []
  );

  return (
    <form onSubmit={handleSubmit(onNext)} autoComplete="on">
      <NameQuestion
        errors={errors}
        control={control}
        stateKey={FIRST_NAME}
        defaultValue={defaultFirstName}
        autoCompleteName="given-name"
        question={FIRST_NAME_QUESTION}
        changeHandler={handleChange}
      />
      <NameQuestion
        stateKey={LAST_NAME}
        errors={errors}
        control={control}
        question={LAST_NAME_QUESTION}
        defaultValue={defaultLastName}
        autoCompleteName="family-name"
        changeHandler={handleChange}
      />
      <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
    </form>
  );
};

export default PersonalPolicyContactStep;
